// Auto-generated cornerstone translation for lv.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T15:21:46.753992+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Zirgu pārvaldības lietotne: labākā izvēle 2026. gadam | EquiSight",
      description: "Salīdziniet zirgu pārvaldības lietotnes īpašniekam, stallim un audzētavai. Uzziniet, kāpēc EquiSight ir pilnīgā lietotne jūsu zirgam.",
      keywords: [
        "zirgu pārvaldības lietotne",
        "stalla pārvaldības lietotne",
        "zirgu žurnāla lietotne",
        "lietotne vairāku zirgu pārvaldībai",
        "ķēves grūsnības lietotne",
        "zirgu audzētavas lietotne",
        "labākā zirgu pārvaldības lietotne",
      ],
    },
    hero: {
      eyebrow: "Izvēles palīgs · zirgu pārvaldības programmatūra",
      breadcrumbLabel: "Zirgu pārvaldības lietotne",
      title: "Zirgu pārvaldības lietotne: pilnīgs izvēles palīgs īpašniekiem, stalliem un audzētavām.",
      intro: "Ne tikai funkciju saraksts — godīgs salīdzinājums, izvēles palīgs un skats uz to, kam zirgu pārvaldības lietotnei 2026. gadā tiešām jāspēj. Vienam zirgam, veselam stallim vai jūsu audzētavai.",
      pills: [
        {
          icon: "Users",
          label: "Īpašniekiem",
        },
        {
          icon: "Building2",
          label: "Stalliem",
        },
        {
          icon: "Baby",
          label: "Audzētavām",
        },
        {
          icon: "Share2",
          label: "Komandām",
        },
      ],
      ctas: [
        {
          label: "Sākt bez maksas ar 1 zirgu",
          href: "#start",
          primary: true,
        },
        {
          label: "Uz salīdzinājuma tabulu",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Kāpēc zirgu pārvaldības lietotne kļūst arvien svarīgāka.",
      lead: "Zirgu pārvaldība praksē ir sadrumstalota: WhatsApp, kalendārs, Excel, telefona fotogrāfijas, papīra pase, atsevišķi rēķini un mutiski vienošanās. Pat pie viena zirga tas ir neērti. Vairākiem zirgiem, audzētavām vai dalītai kopšanai rodas robi, nokavētas tikšanās un strīdi.",
      items: [
        "Kad bija tā vakcinācijas datums?",
        "Kurš samaksāja kalējam?",
        "Kura ķēve šodien jāpārbauda?",
        "Vai treneris izlasīja pagājušās nedēļas norādījumu?",
        "Vai es tiešām saglabāju to foto dokumentu?",
        "Vai stallī piekārtais barošanas grafiks vēl ir aktuāls?",
      ],
    },
    what: {
      title: "Kas ir zirgu pārvaldības lietotne?",
      lead: "Zirgu pārvaldības lietotne pēc būtības ir digitāla lieta par katru zirgu. Ne sadrumstaloti pieraksti, bet viena vieta veselībai, treniņiem, barošanai, dokumentiem, plānošanai, atgādinājumiem, izdevumiem, fotogrāfijām, videoklipiem un dalītai piekļuvei. Ikviens ap zirgu skatās uz vienu un to pašu aktuālo informāciju.",
      targetGroupsTitle: "Kam paredzēta zirgu pārvaldības lietotne?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Privātīpašnieks",
          body: "Viens zirgs, viena lieta — veselība, plānošana un vēsture kabatā.",
        },
        {
          icon: "Users",
          title: "Īpašnieks ar vairākiem zirgiem",
          body: "Atsevišķi profili, atsevišķa plānošana, kopīgs uzdevumu saraksts visai komandai.",
        },
        {
          icon: "Building2",
          title: "Pansijas stalls un manēža",
          body: "Īpašnieka piekļuve, kopšanas norādījumi, kopīgs kalendārs un uzdevumi.",
        },
        {
          icon: "Baby",
          title: "Audzētava",
          body: "Ķēves cikls, grūsnība, ērzeļa dati, ciltsraksts un kumeļa attīstība.",
        },
        {
          icon: "Target",
          title: "Treneri",
          body: "Pārskats par katru zirgu, sesiju reģistrēšana, mērķu izvirzīšana, video analīze.",
        },
        {
          icon: "ClipboardList",
          title: "Speciālisti",
          body: "Kalējs, zobārsts, fizioterapeits vai veterinārārsts — strādā no vienas lietas.",
        },
      ],
    },
    criteria: {
      title: "Kādām prasībām jāatbilst labai zirgu pārvaldības lietotnei?",
      lead: "Lietotne nav tikai skaista — tai jāstrādā praktiski ikdienā. Piecas sastāvdaļas, kas nedrīkst trūkt 2026. gada izvēlē.",
      items: [
        {
          icon: "FileText",
          title: "Zirga lieta katram zirgam",
          body: "Dati, vecums, šķirne, pases informācija, īpašnieks, stalls, fotogrāfijas un dokumenti — visi saistīti ar vienu zirga profilu.",
        },
        {
          icon: "Heart",
          title: "Veselība un kopšana",
          body: "Vakcinācijas, antihelmintiskā terapija, kalējs, zobārsts, veterinārārsts, procedūras, zāles un automātiski atgādinājumi pirms termiņa beigām.",
        },
        {
          icon: "Activity",
          title: "Treniņi un progress",
          body: "Treniņu reģistrēšana, piezīmes, video, sacensību rezultāti, mērķi un progress pa disciplīnām vai zirgiem.",
        },
        {
          icon: "Apple",
          title: "Barošana un pārvaldība",
          body: "Barošanas grafiki, piedevas, rupjā barība, svars, ķermeņa kondīcija un ikdienas rutīna, kas stallim jāzina.",
        },
        {
          icon: "Share2",
          title: "Dalīšanās ar citiem",
          body: "Piekļuve īpašniekam, kopējam, trenerim, stalla turētājam vai speciālistam — ar tiesību pārvaldību atbilstoši katras personas lomai.",
        },
        {
          icon: "Calendar",
          title: "Plānošana un atgādinājumi",
          body: "Kopīgs kalendārs ar uzdevumiem, automātiskiem atgādinājumiem un apstiprinājumu, lai nekas neizslīdētu cauri.",
        },
      ],
    },
    comparison: {
      title: "EquiSight pret citām zirgu pārvaldības lietotnēm.",
      lead: "Pašlaik tirgū konkurē Stalmanager, LogMyHorse, EquineM un Happie Horse. Katram ir savas stiprās puses. Mēs salīdzinām visbiežāk pieprasītās funkcijas, godīgi un pamatojoties uz publiski pieejamu informāciju.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Bezmaksas sākums",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Vairāki zirgi",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Veselības lieta",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Treniņi un progress",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Barošana un piedevas",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Plānošana un atgādinājumi",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumenti katram zirgam",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dalīšanās ar komandu un tiesības",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Audzētavas modulis (pilns)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ķēves cikls",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Grūsnības plānošana un ehoskopija",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kumeļa attīstība",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Speciālistu integrācija",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach ieskati",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Piemērots īpašniekam",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Piemērots audzētavai",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Piemērots stallim/manēžai",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Salīdzinājums balstīts uz publiski pieejamām funkcijām 2026. gada janvārī. Konkurenti ir arī labi rīki; EquiSight ir veidots, lai apvienotu visus moduļus vienā lietotnē.",
    },
    why: {
      title: "Kāpēc EquiSight ir atšķirīgs.",
      lead: "Žurnāls reģistrē. EquiSight apvieno zirgu pārvaldību, treniņus, barošanu, veselību, sacensības, speciālistus un audzētavu vienā modernā lietotnē — un iet soli tālāk ar ieskatu sniegšanu.",
      points: [
        {
          icon: "Heart",
          title: "Viena lietotne visam zirga mūžam",
          body: "No kumeļa līdz sporta zirgam, audzēšanas ķēvei vai penzionētam zirgam. Lieta aug kopā ar jūsu zirgu — nekas nepazūd pa ceļam.",
        },
        {
          icon: "Sparkles",
          title: "Ne tikai dati, bet arī likumsakarības",
          body: "EquiCoach apvieno attīstību, atkārtojošās sūdzības, treniņus un barošanu — lai jūs savlaicīgi pamanītu signālus, nevis atsevišķus paziņojumus.",
        },
        {
          icon: "Share2",
          title: "Veidots sadarbībai",
          body: "Īpašnieks, stalla turētājs, treneris, kalējs un citi speciālisti strādā no vienas zirga lietas — ar tiesībām, kas atbilst viņu lomai.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Niša · audzētava",
      title: "Zirgu pārvaldība audzētavām.",
      lead: "Daudzi konkurenti piemin audzētavu vienā rindā. EquiSight izveidoja pilnīgu audzētavas moduli — jo audzētājs reti ir vispārīgas lietotnes gala lietotājs, taču plānošana viņam vajadzīga vairāk nekā jebkam citam.",
      items: [
        "Ikdienas ķēves cikla uzraudzība",
        "Apsēklošanas datums un ērzeļa dati",
        "Grūsnības kontrole ar ehoskopiju",
        "Paredzamais atnešanās datums un brīdinājumi",
        "Kumeļa attīstība pa mēnešiem",
        "Ciltsraksts un izcelsme",
        "Piezīmes par katru ķēvi",
        "Visu grūsno ķēvju pārskats",
      ],
      ctaLabel: "Skatīt audzētavas moduli",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Niša · stalls un manēža",
      title: "Zirgu pārvaldība vairākiem zirgiem un pansijas stalliem.",
      lead: "Vairāku zirgu gadījumā mazāk svarīgi ir dati, bet vairāk — komunikācija. Katram īpašniekam ir savas vēlmes, rutīnas, barošanas vienošanās un medicīniski apsvērumi. Katram darbiniekam jāspēj pie tiem piekļūt bez meklēšanas.",
      cards: [
        {
          t: "Zirgi pēc īpašnieka",
          d: "Katrs īpašnieks redz tikai savus zirgus.",
        },
        {
          t: "Kopšanas norādījumi",
          d: "Katram zirgam redzami stallim.",
        },
        {
          t: "Kopīgs kalendārs",
          d: "Kalējs, veterinārārsts un sacensības vienā skatā.",
        },
        {
          t: "Uzdevumu saraksts",
          d: "Piešķirt darbiniekiem ar apstiprinājumu.",
        },
        {
          t: "Īpašnieka piekļuve",
          d: "Klienti redz savu zirgu savā lietotnē.",
        },
        {
          t: "Ārkārtas kontakti",
          d: "Vienmēr atrodami stresa brīžos stallī.",
        },
      ],
      ctaLabel: "Skatīt manēžas moduli",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "No WhatsApp, Excel un tāfeles uz EquiSight.",
      lead: "Konkrēti: tā mainās jūsu ikdienas zirgu pārvaldība.",
      rows: [
        {
          before: "WhatsApp grupas",
          after: "Strukturētas piezīmes par katru zirgu",
        },
        {
          before: "Excel tabulas",
          after: "Tiešraides zirga lieta ar vēsturi",
        },
        {
          before: "Tāfele stallī",
          after: "Kopīga plānošana telefonā",
        },
        {
          before: "Atsevišķas fotokameras bildes",
          after: "Mediji saistīti ar jūsu zirgu",
        },
        {
          before: "Mutiskas vienošanās",
          after: "Uzdevumi un atgādinājumi ar apstiprinājumu",
        },
        {
          before: "Pazaudēta papīra pase",
          after: "Dokumenti vienmēr pieejami",
        },
      ],
    },
    helper: {
      title: "Kura zirgu pārvaldības lietotne jums piemērota?",
      lead: "Atbildiet uz šiem 5 jautājumiem un saņemiet godīgu ieteikumu — pat ja tas ne vienmēr būs EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Vai jums ir viens vai vairāki zirgi?",
          options: [
            {
              label: "Viens zirgs",
              score: 1,
            },
            {
              label: "2–5 zirgi",
              score: 2,
            },
            {
              label: "Vairāk nekā 5 zirgi",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Vai pārvaldāt klientu vai trešo personu zirgus?",
          options: [
            {
              label: "Nē, tikai savus zirgus",
              score: 0,
            },
            {
              label: "Dažreiz — ģimenes vai paziņu zirgus",
              score: 1,
            },
            {
              label: "Jā, profesionāli (stalls / manēža)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Vai vēlaties sekot audzēšanai un grūsnībai?",
          options: [
            {
              label: "Nav aktuāli",
              score: 0,
            },
            {
              label: "Dažreiz — gadījuma audzēšana",
              score: 1,
            },
            {
              label: "Jā, esmu (vai kļūšu par) audzētāju",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Vai sadarbojaties ar treneri, kopēju vai speciālistu?",
          options: [
            {
              label: "Nē, visu daru pats",
              score: 0,
            },
            {
              label: "Jā, ar 1 personu",
              score: 1,
            },
            {
              label: "Jā, ar vairākām personām",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Vai vēlaties tikai reģistrēt vai arī gūt ieskatus?",
          options: [
            {
              label: "Tikai reģistrēt",
              score: 1,
            },
            {
              label: "Reģistrēt un plānot",
              score: 2,
            },
            {
              label: "Reģistrēt, plānot un gūt ieskatus",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Vienkāršs žurnāls ir pietiekams — un aug kopā ar jums.",
          body: "Vienam zirgam bez dalītas kopšanas jebkura zirgu pārvaldības lietotne ir piemērota. EquiSight sākas bez maksas ar 1 zirgu, tāpēc riska nav. Ja vēlāk gribēsiet pievienot vairākus zirgus, treneri vai audzētavu, viss jau būs iekšā.",
          cta: "Sākt bez maksas ar 1 zirgu",
        },
        mid: {
          title: "EquiSight labi atbilst jūsu situācijai.",
          body: "Jums ir vairākas vajadzības (vairāki zirgi, sadarbība vai ieskati). Lielākā daļa konkurentu sedz 1–2 moduļus; EquiSight tos apvieno vienā lietotnē, nepiesaistot atsevišķus rīkus.",
          cta: "Skatīt, ko EquiSight piedāvā",
        },
        high: {
          title: "EquiSight ir visloģiskākā izvēle.",
          body: "Jūsu situācija apvieno vairākus zirgus, sadarbību, audzētavu un/vai ieskatus. Tieši šeit EquiSight rada atšķirību — ne sadrumstaloti rīki, bet viena zirga lieta visam un visiem ap zirgu.",
          cta: "Sākt bez maksas ar EquiSight",
        },
      },
    },
    faqTitle: "Biežāk uzdotie jautājumi par zirgu pārvaldības lietotnēm",
    faq: [
      {
        q: "Kura ir labākā zirgu pārvaldības lietotne?",
        a: "Labākā zirgu pārvaldības lietotne ir atkarīga no jūsu situācijas. Vienkāršam žurnālam piemērotas ir vairākas lietotnes. Ja vēlaties apvienot veselību, treniņus, barošanu, dokumentus, audzētavu, plānošanu un sadarbību, tad EquiSight ir veidots kā pilnīgs risinājums, kurā viss sanāk kopā vienā lietā.",
      },
      {
        q: "Vai es varu pārvaldīt vairākus zirgus vienā lietotnē?",
        a: "Jā. Labai zirgu pārvaldības lietotnei jāatbalsta vairāki zirgi, tostarp īpašnieki, kopēji, rutīnas, dokumenti, tikšanās un atgādinājumi katram zirgam. EquiSight ir projektēts šim nolūkam no pirmās koda rindas — zirgi ir individuālas lietas, nevis rindas sarakstā.",
      },
      {
        q: "Vai EquiSight ir piemērots arī audzētavām?",
        a: "Jā. EquiSight var konfigurēt ar audzēšanas funkcijām, piemēram, ķēves ciklu, apsēklošanas datumu, grūsnības kontroli, ērzeļa datiem, ciltsrakstu, paredzamo atnešanās datumu un kumeļa attīstību. Tieši šajā jomā lielākā daļa konkurējošo lietotņu nepiedāvā vai gandrīz nepiedāvā nekā.",
      },
      {
        q: "Vai es varu kopīgot datus ar treneri vai kalēju?",
        a: "Jā. EquiSight mērķis ir droši kopīgot attiecīgo informāciju ar cilvēkiem ap zirgu — treneri, kalēju, zobārstu, veterinārārstu, fizioterapeitu, kopēju vai īpašnieku. Katrs saņem tikai tās tiesības, kas nepieciešamas viņa lomai.",
      },
      {
        q: "Kāpēc neizmantot vienkārši WhatsApp vai Excel?",
        a: "WhatsApp un Excel darbojas, kamēr viss ir vienkārši. Tiklīdz ir vairāki zirgi, tikšanās, dokumenti, procedūras, īpašnieki vai audzēšanas dati, tas kļūst kļūdaini: informācija izkliedējas, meklēšana aizņem laiku un mutiskas vienošanās pazūd. Zirgu pārvaldības lietotne visu apkopo katram zirgam ar automātiskiem atgādinājumiem.",
      },
      {
        q: "Cik maksā EquiSight?",
        a: "Varat sākt bez maksas ar 1 zirgu. Ja vēlaties pārvaldīt vairākus zirgus, aktivizēt audzētavas funkcijas vai piešķirt piekļuvi speciālistiem, pieejami pieejamu cenu Premium plāni. Apskatiet aktuālās iespējas cenu lapā.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Audzēšanas programmatūra zirgiem: pilns salīdzinājums 2026",
      description: "Salīdziniet audzēšanas programmatūru zirgiem: ķēves cikls, grūsnība, kumeļa izvēle un kumeļi. Uzziniet, kāpēc EquiSight ir pilnīgākā audzēšanas lietotne.",
      keywords: [
        "audzēšanas programmatūra zirgiem",
        "ķēves cikla lietotne",
        "ķēves grūsnības lietotne",
        "kumeļa reģistrācijas lietotne",
        "ciltsgrāmatas lietotne zirgiem",
        "pārošanas plānošana zirgiem",
        "kumeļa izvēles lietotne",
      ],
    },
    hero: {
      eyebrow: "Izvēles palīgs · audzēšanas programmatūra",
      breadcrumbLabel: "Audzēšanas programmatūra",
      title: "Audzēšanas programmatūra zirgiem: pilns salīdzinājums 2026. gadam.",
      intro: "Audzēšanas ķēve ir pelnījusi vairāk nekā parasta zirgu pārvaldības lietotne. Salīdziniet populārāko rīku audzēšanas funkcijas, uzziniet, uz ko patiešām jāpievērš uzmanība, un apzināti izvēlieties programmatūru, kas der jūsu audzētavai — lielai vai mazai.",
      pills: [
        {
          icon: "Baby",
          label: "Ķēves cikls",
        },
        {
          icon: "Heart",
          label: "Grūsnības kontrole",
        },
        {
          icon: "Sparkles",
          label: "Kumeļa attīstība",
        },
        {
          icon: "FileText",
          label: "Ciltsgrāmata",
        },
      ],
      ctas: [
        {
          label: "Sāciet bez maksas ar audzēšanas moduli",
          href: "#start",
          primary: true,
        },
        {
          label: "Uz salīdzinājuma tabulu",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Kāpēc parasta zirgu pārvaldības lietotne nav pietiekama audzēšanai.",
      lead: "Lielākā daļa zirgu sporta lietotņu ir izstrādātas vienam sporta vai atpūtas zirgam. Audzēšanai ir pavisam cits ritms: estrus, inseminācija, grūsnības kontrole, ehoskopija, kumeļu kalendārs, ciltsraksts un pārdošana. Viens Excel fails pēc 2 sezonām zaudē kārtību — un, ja ir vairākas ķēves, kontrole pazūd.",
      items: [
        "Kad tieši bija Bonitas pēdējais cikls?",
        "Kurš kumeļš ir plānots pārošanai nākamajā sezonā?",
        "Vai 21. dienas ehoskopija jau ir ieplānota?",
        "Kuri 2024. gada kumeļi jau ir pārdoti?",
        "Kur ir ciltsraksta shēma līdz mātes pusei vectēvam?",
        "Kur atrodas DNS paraugi un pases dati?",
      ],
    },
    what: {
      title: "Kas ir audzēšanas programmatūra zirgiem?",
      lead: "Audzēšanas programmatūra ir specializēta lieta katrai ķēvei un kumeļam, apvienota ar audzēšanas gada kalendāru, grūsnības plānošanu, kumeļa reģistrāciju un ciltsraksta attēlojumu. Nevis vispārējs zirgu žurnāls, bet rīks, kas saprot audzēšanas ciklu: no pirmā estrusa līdz atšķiršanai.",
      targetGroupsTitle: "Kāda tipa audzētājiem paredzēta audzēšanas programmatūra?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobija audzētājs (1–3 ķēves)",
          body: "Viena vai divas pārošanas gadā — pārskats bez Excel akrobātikas.",
        },
        {
          icon: "Building2",
          title: "Maza audzētava (4–10 ķēves)",
          body: "Audzēšanas gada plāns ar ciklu, insemināciju, grūsnības kontroli un kumeļa lietu.",
        },
        {
          icon: "Users",
          title: "Profesionāla audzētava (10+)",
          body: "Vairāki darbinieki, kumeļa izvēle katrai ķēvei, pārdošana un mārketings.",
        },
        {
          icon: "Target",
          title: "Kumeļu turētājs",
          body: "Pasūtījumu vēsture, spermas statistika un grafiks katram kumeļam.",
        },
        {
          icon: "Heart",
          title: "Embriju transplantācija",
          body: "Donors + recipientķēve kā savienota lieta, ET-kalendārs.",
        },
        {
          icon: "ClipboardList",
          title: "Ciltsgrāmatas reģistrācija",
          body: "DNS paraugi, pases dokumenti un ciltsraksta dati.",
        },
      ],
    },
    criteria: {
      title: "Kādām prasībām jāatbilst labai audzēšanas programmatūrai?",
      lead: "Ne katra 'audzēšanas funkcija' zirgu lietotnē ir vienāda. Piecas galvenās jomas, kurās audzētāji zaudē daudz laika — un kur programmatūra patiešām palīdz.",
      items: [
        {
          icon: "Calendar",
          title: "Ķēves cikls un estrus",
          body: "Ikdienas žurnāls, ovulācijas prognozēšana, cikla turpinājums un automātiski atgādinājumi.",
        },
        {
          icon: "Heart",
          title: "Inseminācija un grūsnības kontrole",
          body: "Pārošanas un inseminācijas datumi, kumeļa dati, 14 dienu ehoskopija, 21 dienas ehoskopija, 60 dienu ehoskopija un dzimuma noteikšana.",
        },
        {
          icon: "Baby",
          title: "Kumeļa attīstība",
          body: "Dzimšanas dati, svara grafiks, pretparazītu shēma, atšķiršanas brīdis, pases reģistrācija.",
        },
        {
          icon: "FileText",
          title: "Ciltsraksts un dokumenti",
          body: "Ciltsraksta attēlojums līdz 4–5 paaudzēm, DNS, pases numuri un ciltsgrāmatas statuss.",
        },
        {
          icon: "Target",
          title: "Kumeļa izvēle un atbilstība",
          body: "Filtrēšana pēc disciplīnas, līnijām, kumeļa datiem un vēsturiskajiem rezultātiem — nevis tikai tas, ko reklamē kumeļa turētājs.",
        },
        {
          icon: "Share2",
          title: "Sadarbība ar veterinārārstu/inseminātoru",
          body: "Ehoskopijas, paraugi un statusi tieši kopīgoti ar praksi, kas strādā ar jūsu ķēvēm.",
        },
      ],
    },
    comparison: {
      title: "EquiSight salīdzinājumā ar citu audzēšanas programmatūru.",
      lead: "Latvijas meklēšanas rezultātos audzēšanas programmatūrai bieži parādās vispārīgas zirgu lietotnes, kas audzēšanu piemin tikai vienā teikumā. Mēs godīgi salīdzinām, kuriem rīkiem patiešām ir pilnīga audzēšanas plūsma.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Bezmaksas sākums",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Ķēves cikla reģistrācija",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Inseminācijas datums + kumeļš",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ehoskopija un grūsnības kontrole",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Paredzamais kumeļa dzimšanas datums",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Kumeļa lieta (svars/augšana)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Ciltsraksts līdz 4–5 paaudzēm",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNS un pases reģistrācija",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Kumeļa izvēle / atbilstība",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embriju transplantācija",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Vairāku ķēvju pārskats",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobilā lietotne (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kopīgošana ar veterinārārstu",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrēts ar vispārējo lietu",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kumeļu pārdošana un mārketings",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Salīdzinājums balstīts uz publiski pieejamām funkcijām 2026. gada janvārī. EquineGenie ir spēcīgs audzēšanā, taču vājāks mobilajā lietotnē un vispārējā zirgu pārvaldībā. EquiSight apvieno abas.",
    },
    why: {
      title: "Kāpēc EquiSight apkalpo audzētājus citādi.",
      lead: "Daudzi audzētāji izmanto atsevišķu audzēšanas programmatūru un atsevišķu zirgu pārvaldības lietotni. EquiSight apvieno abas — bez nepieciešamības pārslēgties starp lietotnēm vai ievadīt datus divreiz.",
      points: [
        {
          icon: "Heart",
          title: "Audzēšanas ķēve paliek arī parasts zirgs",
          body: "Audzēšanas ķēvei ir gan audzēšanas gads, gan parasta zirga lieta — veselība, vakcinācijas, kalējs. Viena lietotne, visas moduļi.",
        },
        {
          icon: "Sparkles",
          title: "Prognozējoši, nevis reaktīvi",
          body: "Cikla prognoze, grūsnības atskaites punktu atgādinājumi un kumeļu kalendārs — automātiski, pamatojoties uz jūsu datiem.",
        },
        {
          icon: "Share2",
          title: "Visi, kas iesaistīti audzēšanā",
          body: "Inseminātors, kumeļa turētājs, veterinārārsts, pircējs, ciltsgrāmata — visiem piekļuve ar atbilstošām tiesībām.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Pēc disciplīnas · no cikla līdz atšķiršanai",
      title: "Ko satur audzēšanas lieta EquiSight sistēmā.",
      lead: "Katrai ķēvei jūs saņemat pilnu audzēšanas lietu, kas saistīta ar viņas parasto zirga lietu.",
      items: [
        "Ikdienas cikla žurnāls ar prognozi",
        "Inseminācija/pārošana + kumeļa dati",
        "Ehoskopijas laika skala (14/21/60 dienas + dzimums)",
        "Grūsnības atskaites punkti ar automātiskiem atgādinājumiem",
        "Paredzamais dzimšanas datums un sagatavošanās",
        "Kumeļa lieta no dzimšanas brīža",
        "Ciltsraksts līdz vectēvam/vecmāmiņai ar klikšķu navigāciju",
        "DNS paraugs, pase, ciltsgrāmatas statuss",
        "Pārdošanas cauruļvads ar interesentiem",
        "Kumeļa izvēles vēsture katrai ķēvei",
      ],
      ctaLabel: "Skatīt audzēšanas moduli",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Visai audzētavai",
      title: "Pārskats par vairākām ķēvēm un kumeļiem.",
      lead: "Kad audzējat vairāk nekā 2–3 ķēves, pārskats par visiem cikliem un grūsnībām kļūst ļoti svarīgs.",
      cards: [
        {
          t: "Cikla informācijas panelis",
          d: "Visas ķēves blakus, ar cikla fāzi un nākamo darbību.",
        },
        {
          t: "Grūsnības cauruļvads",
          d: "Kuras ķēves atrodas kurā grūsnības atskaites punktā?",
        },
        {
          t: "Kumeļu kalendārs",
          d: "Paredzamās dzimšanas pa mēnešiem, ar loģistiku atbilstoši plānotu.",
        },
        {
          t: "Kumeļa portfelis",
          d: "Pašu kumeļi vai pastāvīgi inseminātori ar pasūtījumu vēsturi.",
        },
        {
          t: "Ciltsraksta grafiks",
          d: "Senču analīze pa vairākām paaudzēm un līnijām.",
        },
        {
          t: "Pārdošanas informācijas panelis",
          d: "Kuri kumeļi ir pārdoti, rezervēti vai vēl pieejami.",
        },
      ],
    },
    beforeAfter: {
      title: "No Excel un kalendāra uz EquiSight audzēšanu.",
      lead: "Konkrēti: tā mainās jūsu audzēšanas sezona.",
      rows: [
        {
          before: "Cikls atsevišķā piezīmē",
          after: "Ikdienas žurnāls ar prognozi",
        },
        {
          before: "Ehoskopijas caur WhatsApp inseminātorам",
          after: "Kopīgota lieta ar fotogrāfijām",
        },
        {
          before: "Grūsnības datums kalendārā",
          after: "Automātiski atskaites punktu atgādinājumi",
        },
        {
          before: "Kumeļa pase atvilktnē",
          after: "Dokuments pievienots kumeļa profilam",
        },
        {
          before: "Ciltsraksts uz papīra",
          after: "Klikšķināms ciltsraksts līdz 4–5 paaudzēm",
        },
        {
          before: "Pārdošanas sludinājums Marktplaats",
          after: "Pārdošanas cauruļvads ar interesentu sarakstu",
        },
      ],
    },
    helper: {
      title: "Kura audzēšanas programmatūra der jums?",
      lead: "5 jautājumi, lai noskaidrotu, vai jums nepieciešama pilnīga audzēšanas lietotne vai pietiek ar hobija rīku.",
      questions: [
        {
          id: "mares",
          q: "Cik audzēšanas ķēvju jums ir?",
          options: [
            {
              label: "1 ķēve",
              score: 1,
            },
            {
              label: "2–5 ķēves",
              score: 2,
            },
            {
              label: "Vairāk nekā 5 ķēves",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Cik bieži audzējat gadā?",
          options: [
            {
              label: "Neregulāri (ik pāris gadus)",
              score: 0,
            },
            {
              label: "Katru gadu 1–2 pārošanas",
              score: 2,
            },
            {
              label: "Katru gadu 3+ pārošanas",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Kā veiciet insemināciju/pārošanu?",
          options: [
            {
              label: "Dabiskā pārošana",
              score: 1,
            },
            {
              label: "MI svaiga/atdzesēta sperma",
              score: 2,
            },
            {
              label: "ET vai saldēta sperma",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Vai sadarbojaties ar veterinārārstu/inseminātoru?",
          options: [
            {
              label: "Viena pastāvīga persona",
              score: 1,
            },
            {
              label: "Vairākas prakses",
              score: 2,
            },
            {
              label: "Starptautisks tīkls",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Ko jūs pašlaik reģistrējat?",
          options: [
            {
              label: "Excel vai papīrs",
              score: 1,
            },
            {
              label: "Vispārēja zirgu pārvaldības lietotne",
              score: 2,
            },
            {
              label: "Nekas strukturēts",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Pietiek ar hobija rīku vai Excel — taču EquiSight joprojām ir noderīgs.",
          body: "Vienai ķēvei ar dabisko pārošanu ik pāris gadus pilnvērtīgs audzēšanas modulis ir lieks. EquiSight ir bezmaksas, un audzēšanas moduli aktivizējat tikai tam gadam, kad audzējat — bez obligātas jaunināšanas.",
          cta: "Sāciet bez maksas",
        },
        mid: {
          title: "EquiSight audzēšanas modulis ir īstais rīks.",
          body: "Jums ir vairākas ķēves vai vairākas audzēšanas metodes — vispārējas zirgu lietotnes tam nav paredzētas. EquiSight apvieno audzēšanu un vispārējo aprūpi, lai jums nebūtu jāpārslēdzas starp diviem rīkiem.",
          cta: "Skatīt audzēšanas moduli",
        },
        high: {
          title: "EquiSight ir veidots jūsu audzētavai.",
          body: "Vairākas ķēves, ET vai saldēta sperma, starptautiska komanda — lielākā daļa rīku šeit nespēj tikt galā. EquiSight mērogojams līdz audzētavas līmenim, neuzkrājot papildu licences.",
          cta: "Sazinieties ar mums par audzētavas plānu",
        },
      },
    },
    faqTitle: "Biežāk uzdotie jautājumi par audzēšanas programmatūru",
    faq: [
      {
        q: "Kāda ir labākā audzēšanas programmatūra zirgiem?",
        a: "Vienai ķēvei bez sarežģītas audzēšanas metodes daudzi rīki ir pietiekami. Sākot no 2–3 ķēvēm, izmantojot MI vai ET, vai sadarbojoties ar veterinārārstu un ciltsgrāmatu, pilnvērtīgs audzēšanas modulis kļūst ļoti svarīgs. EquiSight apvieno audzēšanu ar vispārējo zirgu pārvaldību vienā lietotnē, lai jums nebūtu jāpārslēdzas.",
      },
      {
        q: "Kādas audzēšanas funkcijas man patiešām vajadzīgas?",
        a: "Minimums: cikla žurnāls, inseminācijas/pārošanas dati, grūsnības kontroles atskaites punkti un kumeļa lieta. Papildu, taču ļoti noderīgas: ciltsraksta attēlojums, kumeļa izvēles arhīvs, DNS/pase un pārdošanas cauruļvads.",
      },
      {
        q: "Vai EquiSight var prognozēt ķēves ciklu?",
        a: "Jā. EquiSight izmanto iepriekšējos cikla datus, lai parādītu prognozēto ovulāciju, ļaujot jums plānot insemināciju vai pārošanu īstajā brīdī — bez ikdienas minēšanas.",
      },
      {
        q: "Vai EquiSight darbojas arī embriju transplantācijai?",
        a: "Jā. Donora un recipientķēvei tiek izveidotas savienotas lietas, ET-kalendārs un kopīgoti atskaites punkti ar praksi. Tā jūs nezaudējat laika skalu sarežģītajā ET procesā.",
      },
      {
        q: "Vai es varu importēt esošos audzēšanas datus?",
        a: "Ciklu, pārošanu un kumeļu datus varat ievadīt manuāli vai grupā, izmantojot CSV. Aktīvām audzētavām ar datu par vairākām sezonām mēs palīdzam ar vienreizēju migrāciju.",
      },
      {
        q: "Kā kopīgot lietu ar savu veterinārārstu vai inseminātoru?",
        a: "Katrai personai tiek piešķirta piekļuve ar lomu: veterinārārsts, inseminātors, kumeļa turētājs vai ciltsgrāmatas darbinieks. Katrs redz tikai informāciju, kas nepieciešama viņa lomai — nav nepieciešama pilna piekļuve.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Manēžas programmatūra: pilns salīdzinājums & izvēles palīgs 2026",
      description: "Salīdzini manēžas programmatūru nodarbībām, jātniekiem, zirgiem un administrācijai. Atklāj, kura lietotne der tieši tavai manēžai vai pensionātu stallim.",
      keywords: [
        "manēžas programmatūra",
        "staļļa pārvaldības lietotne",
        "manēžas administrācijas programmatūra",
        "nodarbību plānošana manēžā",
        "pensionātu staļļa programmatūra",
        "jātnieku administrācija",
        "zirgu administrācija manēžā",
      ],
    },
    hero: {
      eyebrow: "Izvēles palīgs · manēžas programmatūra",
      breadcrumbLabel: "Manēžas programmatūra",
      title: "Manēžas programmatūra: pilnīgais izvēles palīgs manēžām un pensionātu staļļiem.",
      intro: "Nodarbību plānošana, jātnieku administrācija, zirgu pārvaldība, rēķinu izrakstīšana un komunikācija — laba manēžas programmatūra apvieno visu kopā. Salīdzini populārākās iespējas un atklāj, kura der tieši tavam stallim vai manēžai.",
      pills: [
        {
          icon: "Calendar",
          label: "Nodarbību plānošana",
        },
        {
          icon: "Users",
          label: "Jātnieki & klienti",
        },
        {
          icon: "Heart",
          label: "Zirgu aprūpe",
        },
        {
          icon: "CreditCard",
          label: "Rēķinu izrakstīšana",
        },
      ],
      ctas: [
        {
          label: "Pieprasīt demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Uz salīdzināšanas tabulu",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Kāpēc izkliedēti rīki palēnina manēžas darbu.",
      lead: "Lielākā daļa manēžu darbojas ar ielāpu darbu: nodarbību plānošana uz tāfeles, jātnieku reģistrācija Excel, rēķinu izrakstīšana atsevišķā rīkā, zirgu aprūpe WhatsApp un sazināšanās ar īpašniekiem caur personīgiem ziņojumiem. Aizņemtās nedēļās rodas dubultas rezervācijas, aizmirsti rēķini vai zirgi, kas nezina, kurš jātnieks tos saņems.",
      items: [
        "Kurš šobrīd brauc nodarbībā pie Jasmīnas?",
        "Kurš jātnieks vēl nav samaksājis par martu?",
        "Kurš zirgs šonedēļ nedrīkst tikt izmantots?",
        "Kas ir skolēnu ārkārtas kontaktpersonas?",
        "Vai Stardust īpašnieks jau ir saņēmis kalēja rēķinu?",
        "Kurš zirgs atrodas kurā bokā?",
      ],
    },
    what: {
      title: "Kas ir manēžas programmatūra?",
      lead: "Manēžas programmatūra apvieno nodarbību plānošanu, jātnieku administrāciju, zirgu pārvaldību, rēķinu izrakstīšanu un komunikāciju vienā rīkā. Nekādas Excel akrobātikas vai WhatsApp sajukuma — tikai viena vieta, kur manēža strādā un īpašnieki/jātnieki var sekot līdzi.",
      targetGroupsTitle: "Kāda veida uzņēmumiem paredzēta manēžas programmatūra?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Maza manēža (1-15 zirgi)",
          body: "Galvenokārt nodarbību plānošana un maksājumi — administrācija bez galvassāpēm.",
        },
        {
          icon: "Users",
          title: "Vidēja manēža (15-40 zirgi)",
          body: "Vairāki instruktori, nodarbību plānošana + zirgu grafiks + jātnieku administrācija.",
        },
        {
          icon: "ClipboardList",
          title: "Liels jāšanas un pensionātu stallis (40+)",
          body: "Pilna darbība, ieskaitot rēķinu izrakstīšanu, barošanas un kalēja plānošanu.",
        },
        {
          icon: "Heart",
          title: "Pensionātu stallis",
          body: "Īpašnieka portāls, individuāli aprūpes norādījumi, kopīgs kalendārs.",
        },
        {
          icon: "Target",
          title: "Lecamzirgu treniņu stallis",
          body: "Sacensību plānošana, treniņi katram zirgam, klientu kontakts.",
        },
        {
          icon: "FileText",
          title: "Hipiskā uzņēmēji",
          body: "Nodarbību + pensionāta + klīniku + tirdzniecības kombinācija — viss no vienas sistēmas.",
        },
      ],
    },
    criteria: {
      title: "Kādām prasībām jāatbilst labai manēžas programmatūrai?",
      lead: "Skaista lietotne neko nenozīmē, ja darbinieki nevēlas ar to strādāt. Pieci praktiski kritēriji, kas nosaka atšķirību starp panākumiem un vilšanos.",
      items: [
        {
          icon: "Calendar",
          title: "Nodarbību plānošana vairākos līmeņos",
          body: "Iesācēji/pieredzējušie, iejāšana/lēkšana, zirgu saistījumi un instruktoru kalendāri — viss pārskatāms vienlaikus.",
        },
        {
          icon: "Users",
          title: "Jātnieku administrācija",
          body: "Profili, līmenis, abonements, nodarbību karte un ģimenes locekļu saistījumi jaunajiem jātniekiem.",
        },
        {
          icon: "Heart",
          title: "Zirgu grafiks",
          body: "Cik bieži katrs zirgs tiek izmantots, ar atpūtas, traumu un menstruācijas periodiem.",
        },
        {
          icon: "CreditCard",
          title: "Rēķinu izrakstīšana & abonementi",
          body: "Ikmēneša abonementi, nodarbību kartes, atsevišķas nodarbības un automātiska iekasēšana.",
        },
        {
          icon: "Share2",
          title: "Īpašnieku portāls (pensionātu stallis)",
          body: "Īpašnieki redz savu zirgu savā lietotnē — kalendārs, izmaksas, kalējs un piezīmes bez zvanīšanas.",
        },
        {
          icon: "Bell",
          title: "Komunikācija & atgādinājumi",
          body: "Automātiski nodarbību atgādinājumi, maksājumu paziņojumi, kalēja paziņojumi — bez ziņošanas.",
        },
      ],
    },
    comparison: {
      title: "EquiSight pret citu manēžas programmatūru.",
      lead: "Daudzas manēžas programmas ir spēcīgas nodarbību plānošanā vai rēķinu izrakstīšanā, taču reti vienlaikus zirgu aprūpē un saziņā ar īpašniekiem. Mēs godīgi salīdzinām tās vienu pret otru.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Bezmaksas sākums / izmēģinājuma periods",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Nodarbību plānošana",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Vairāki instruktori",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Jātnieku administrācija",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Zirgu grafiks",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Zirgu aprūpe (vakcinācija/kalējs)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Nodarbību karte / abonements",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Tiešsaistes maksājumi",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automātiska rēķinu izrakstīšana",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Īpašnieku portāls (pensionāts)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kalēja/veterinārā integrācija",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/SMS atgādinājumi",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobilais (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Sacensību plānošana",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Piemērots pensionātu stallim",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Salīdzinājums balstīts uz publiski pieejamām funkcijām 2026. gada janvārī. Stalmanager ir spēcīgs administrācijā, EquiSight izceļas ar pensionātu darbplūsmu + zirgu aprūpi + īpašnieku portālu.",
    },
    why: {
      title: "Kāpēc EquiSight ir atšķirīgs manēžām un pensionātu staļļiem.",
      lead: "EquiSight pārsniedz nodarbību plānotāja funkcijas. Mēs uzskatām manēžu par pilnīgu darbību: zirgi, cilvēki, komunikācija un nauda — visi savstarpēji atkarīgi.",
      points: [
        {
          icon: "Heart",
          title: "Zirgs centrā, nevis kalendārs",
          body: "Katram zirgam ir savs lieta. Nodarbību izmantošana, veselība, kalējs un sacensības vienā laika skalā — nevis 3 atsevišķi rīki.",
        },
        {
          icon: "Share2",
          title: "Īpašnieki seko līdzi bez zvanīšanas",
          body: "Pensionātu staļļa īpašniekiem ir savs skats: izmaksas, plānošana, fotogrāfijas un piezīmes — ietaupa 5-10 tālruņa zvanus nedēļā.",
        },
        {
          icon: "Bell",
          title: "Automātiska komunikācija",
          body: "Nodarbību atgādinājums, vakcinācijas atgādinājums, rēķins — automātiski, caur lietotni/e-pastu/SMS. Vairs nav apraides WhatsApp.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Pensionātu stallim",
      title: "Ko pensionātu stallis saņem ar EquiSight.",
      lead: "Pensionātu staļļiem ir unikālas problēmas, ko parastā manēžas programmatūra neatrisina.",
      cards: [
        {
          t: "Īpašnieku portāls",
          d: "Katrs īpašnieks redz tikai savus zirgus, kalendāru un izmaksas.",
        },
        {
          t: "Aprūpes norādījumi katram zirgam",
          d: "Barība, rupjā barība, uztura bagātinātāji, segu grafiks — redzams staļļa darbiniekiem.",
        },
        {
          t: "Kopīgs kalendārs",
          d: "Kalējs, veterinārārsts un īpašnieka apmeklējumi vienā skatā.",
        },
        {
          t: "Patēriņa izmaksas katram zirgam",
          d: "Pakaišu, barības, koncentrātu izmaksas aprēķinātas katram īpašniekam.",
        },
        {
          t: "Ārkārtas kontakti zirgam",
          d: "Īpašnieks + veterinārārsts + kalējs vienmēr atrodni staļļa darbiniekiem.",
        },
        {
          t: "Ganību pārvaldība",
          d: "Kuri zirgi iet ganībās, atpūtā vai rehabilitācijā?",
        },
      ],
    },
    beforeAfter: {
      title: "No tāfeles + Excel uz EquiSight.",
      lead: "Konkrēti: tā mainās darba nedēļa manēžā.",
      rows: [
        {
          before: "Tāfele ar nodarbību plānošanu",
          after: "Tiešraides plānošana katram instruktoram",
        },
        {
          before: "Excel ar jātniekiem + nodarbību piezīmēm",
          after: "Klientu CRM ar nodarbību vēsturi",
        },
        {
          before: "WhatsApp īpašniekiem",
          after: "Īpašnieku portāls viņu zirgam",
        },
        {
          before: "Ikmēneša iekasēšana manuāli",
          after: "Automātiska rēķinu izrakstīšana + iDEAL",
        },
        {
          before: "Zirgu aprūpe uz papīra dēļa",
          after: "Aprūpes norādījumi katram zirgam, koplietoti",
        },
        {
          before: "Mutiska vienošanās ar kalēju",
          after: "Kalēja plānošana ar apstiprinājumiem",
        },
      ],
    },
    helper: {
      title: "Kura manēžas programmatūra der tev?",
      lead: "5 jautājumi, lai noskaidrotu, vai EquiSight ir pareizā platforma tavai manēžai vai pensionātu stallim.",
      questions: [
        {
          id: "size",
          q: "Cik daudz zirgu ir tavā uzņēmumā?",
          options: [
            {
              label: "Mazāk nekā 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Vairāk nekā 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Kāda ir tava galvenā darbība?",
          options: [
            {
              label: "Galvenokārt nodarbību vadīšana",
              score: 1,
            },
            {
              label: "Pensionātu stallis (zirgi pensionātā)",
              score: 3,
            },
            {
              label: "Nodarbību + pensionāta kombinācija",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Ar cik daudziem instruktoriem strādā?",
          options: [
            {
              label: "Tikai es pats",
              score: 1,
            },
            {
              label: "2-3 instruktori",
              score: 2,
            },
            {
              label: "4 vai vairāk",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Kā tu šobrīd kārto rēķinu izrakstīšanu?",
          options: [
            {
              label: "Manuāli (Word/Excel)",
              score: 3,
            },
            {
              label: "Atsevišķa grāmatvedības programma",
              score: 2,
            },
            {
              label: "Integrēts nodarbību rīkā",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Kā tu komunicē ar īpašniekiem?",
          options: [
            {
              label: "Personīgi / WhatsApp",
              score: 3,
            },
            {
              label: "E-pasts + WhatsApp",
              score: 2,
            },
            {
              label: "Īpašnieku portāls rīkā",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Pagaidām var iztikt ar vieglu rīku vai Excel — bet EquiSight aug kopā ar tevi.",
          body: "Mazam nodarbību uzņēmumam ar vienu instruktoru un mazu pensionātu plašs pakotne nav tūlīt nepieciešama. EquiSight sāk bezmaksas un aug kopā ar tavu manēžu — bez migrācijas sāpēm pēc dažiem gadiem.",
          cta: "Sākt bez maksas",
        },
        mid: {
          title: "EquiSight ir loģisks uzlabojums tavai manēžai.",
          body: "Vairāki instruktori, nodarbību un pensionāta kombinācija vai rēķinu izrakstīšana, kas šobrīd ir atsevišķi — EquiSight apvieno to vienā darbplūsmā. Īpaši īpašnieku portāls ievērojami samazina ad hoc komunikāciju.",
          cta: "Pieprasīt demo",
        },
        high: {
          title: "EquiSight ir veidots tieši tavai mērogam.",
          body: "Pensionātu stallis + nodarbības + vairāki instruktori ir tieši tas, kur EquiSight izceļas salīdzinājumā ar klasiskajām manēžas programmām. Īpašnieku portāls un zirgu aprūpes integrācija katru nedēļu ietaupa daudzas administrācijas un komunikācijas stundas.",
          cta: "Plānot demo savam stallim",
        },
      },
    },
    faqTitle: "Biežāk uzdotie jautājumi par manēžas programmatūru",
    faq: [
      {
        q: "Kāda ir labākā manēžas programmatūra?",
        a: "Tīrai nodarbību plānošanai ir vairākas labas iespējas. Brīdī, kad ir nepieciešams pensionātu stallis, vairāki instruktori vai zirgu aprūpes izsekošana, EquiSight kļūst par pilnīgu risinājumu — bez rīku žonglēšanas, viss vienā vietā.",
      },
      {
        q: "Vai es varu importēt esošos klientus un nodarbības?",
        a: "Jā. Klientu datus un nodarbību grafikus var importēt caur CSV. Mēs palīdzam aktīvajām manēžām ar vienreizēju migrāciju, lai tev nebūtu manuāli jāievada 200 jātnieki.",
      },
      {
        q: "Vai tas darbojas arī pensionātu stallim bez nodarbībām?",
        a: "Jā. Pensionātu staļļa režīms izslēdz nodarbības un koncentrējas uz īpašnieku portālu, barošanu/aprūpi, kalēja plānošanu un izmaksu aprēķinu katram zirgam.",
      },
      {
        q: "Vai jātnieki var paši reģistrēties un maksāt?",
        a: "Jā. Jātnieki caur savu kontu var redzēt, kuras nodarbības ir pieejamas, reģistrēties, maksāt mācību maksu ar iDEAL un iegādāties nodarbību kartes.",
      },
      {
        q: "Kā ir ar zirgu un īpašnieku datu privātumu?",
        a: "Katrai personai ir loma (īpašnieks, jātnieks, instruktors, darbinieks). Katrai lomai ir redzams tikai tas, kas nepieciešams. Īpašnieki redz tikai savus zirgus, jātnieki — tikai savas nodarbības.",
      },
      {
        q: "Vai EquiSight var savienot ar manu grāmatvedības programmu?",
        a: "Jā, savienojumi ar Exact, Moneybird un e-Boekhouden ir pieejami. Rēķini tad automātiski tiek nosūtīti uz tavu grāmatvedību.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Treneris lietotne zirgiem: salīdzinājums un izvēles palīgs treneriem 2026",
      description: "Salīdzini treneris lietotnes zirgiem un jātniekiem: treniņu žurnāls, video, mērķi, protokolu analīze un klientu pārvaldība. Atrod piemērotāko rīku treneriem.",
      keywords: [
        "treneris lietotne zirgs",
        "instruktors lietotne",
        "zirgu treniņu lietotne",
        "jātnieka koučinga lietotne",
        "treniņu dienasgrāmata zirgs",
        "iejādes protokola analīze",
        "zirgu treneris programmatūra",
      ],
    },
    hero: {
      eyebrow: "Izvēles palīgs · treneris programmatūra",
      breadcrumbLabel: "Treneris lietotne",
      title: "Treneris lietotne zirgiem: pilnīgs izvēles palīgs instruktoriem un treneriem.",
      intro: "Treneris vai instruktors žonglē ar kombinācijām, nodarbībām, video, mērķiem un sacensībām. Salīdzini labākās treneris lietotnes zirgu pasaulei un izvēlies platformu, kas augs kopā ar tavu koučingu arī 2026. gadā.",
      pills: [
        {
          icon: "Target",
          label: "Mērķi un plānošana",
        },
        {
          icon: "Video",
          label: "Video analīze",
        },
        {
          icon: "TrendingUp",
          label: "Progress",
        },
        {
          icon: "Users",
          label: "Klienti/kombinācijas",
        },
      ],
      ctas: [
        {
          label: "Sāc bez maksas kā treneris",
          href: "#start",
          primary: true,
        },
        {
          label: "Uz salīdzināšanas tabulu",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Kāpēc WhatsApp koučings traucē treneriem.",
      lead: "Lielākā daļa trenerus strādā ar atsevišķiem rīkiem: WhatsApp saziņai, piezīmju blociņš nodarbībām, YouTube vai WeTransfer video, un Excel sacensību rezultātiem. Pie 5 jātniekiem tas darbojas. Pie 20 jātniekiem informācija pazūd, mērķi tiek aizmirsti un individuālais progress kļūst nekontrolējams.",
      items: [
        "Kur ir Anouk mērķis šajā sezonā?",
        "Kuru video es pagājušajā mēnesī nosūtīju Bramam?",
        "Vai Lara ir redzējusi savas pēdējās sacensības protokola analīzi?",
        "Cik bieži nedēļā trenējas katra kombinācija?",
        "Vai Stardust īpašnieks ir izlasījis manus treniņa norādījumus?",
        "Kad pēdējo reizi sniedzu atsauksmi par svārstīgu impulsiju?",
      ],
    },
    what: {
      title: "Kas ir treneris lietotne zirgiem un jātniekiem?",
      lead: "Treneris lietotne apvieno koučinga CRM (kombinācijas, nodarbības, mērķi), treniņu žurnālu katram zirgam, video atsauksmes, sacensību plānošanu un protokola analīzi. Vairs nav atsevišķu WhatsApp/YouTube/Excel — tikai viena platforma, kur treneris un jātnieks strādā kopā.",
      targetGroupsTitle: "Kāda tipa trenerim tas paredzēts?",
      targetGroups: [
        {
          icon: "Target",
          title: "Iejādes instruktors",
          body: "Protokolu skenēšana, žūrijas komentāru sasaiste ar treniņu mērķiem, progresa novērošana.",
        },
        {
          icon: "Activity",
          title: "Pārlēkšanas treneris",
          body: "Maršruta plānošana, kārtas atsauksmes, augstuma pārvaldība katram zirgam.",
        },
        {
          icon: "Award",
          title: "Jāšanas vispusībā treneris",
          body: "Trīs disciplīnas, trīs plānošanas — visas redzamas vienlaikus.",
        },
        {
          icon: "TrendingUp",
          title: "Snieguma koučs (sports)",
          body: "EPI izsekošana, sacensības, mērķi — augsta līmeņa sportistiem un viņu komandām.",
        },
        {
          icon: "Users",
          title: "Manēžas instruktors",
          body: "Grupu nodarbības un individuāls koučings vienā lietotnē.",
        },
        {
          icon: "Heart",
          title: "Rekreatīvais koučs",
          body: "Hipoterapija, iesācēji, īpašnieki ar vienu zirgu.",
        },
      ],
    },
    criteria: {
      title: "Kādām prasībām jāatbilst labai treneris lietotnei?",
      lead: "Treniņi ir cilvēciski, taču pareizais rīks padara tevi par 30–50% efektīvāku un palīdz jātniekiem attīstīties arī starp nodarbībām.",
      items: [
        {
          icon: "Users",
          title: "Kombināciju pārvaldība",
          body: "Zirgs un jātnieks kā viena vienība ar līmeni, mērķiem, progresu un vēsturi.",
        },
        {
          icon: "ClipboardList",
          title: "Nodarbību piezīmes un mērķi",
          body: "Katrā nodarbībā piezīme ar fokusa punktiem, saistīta ar ilgtermiņa mērķiem.",
        },
        {
          icon: "Video",
          title: "Video atsauksmes",
          body: "Augšupielādē video, atzīmē momentus, pievieno runātas vai rakstītas atsauksmes.",
        },
        {
          icon: "Target",
          title: "Sacensību un protokola analīze",
          body: "Skenē protokolus (KNHS/FEI), redzi rezultātus pa elementiem, žūrijas komentārus un tendences.",
        },
        {
          icon: "Calendar",
          title: "Plānošana un nodarbību kartes",
          body: "Kalendārs, maksājumi, abonamenti un automātiski atgādinājumi.",
        },
        {
          icon: "Share2",
          title: "Saziņa ar jātnieku",
          body: "Jātnieks redz savu lapu ar nodarbībām, video, mērķiem un atsauksmēm.",
        },
      ],
    },
    comparison: {
      title: "EquiSight pret citām treneris lietotnēm.",
      lead: "Dažas treneris lietotnes koncentrējas uz WhatsApp aizstāšanu, citas uz protokola analīzi. EquiSight apvieno abus ar īstu zirga dossjē — lai jātnieks attīstītos arī starp nodarbībām.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Bezmaksas sākums",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Kombināciju pārvaldība",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Nodarbību piezīmes un atsauksmes",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ilgtermiņa mērķi",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Video augšupielāde un atsauksmes",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "KNHS/FEI protokola skenēšana",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (snieguma indekss)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sacensību kalendārs",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Jātnieka portāls",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Nodarbību karte / abonaments",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Tiešsaistes maksājumi",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrēts zirga dossjē",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kalējs/veterinārārsts redzams",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Instruktoram UN jātniekam",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Vairāki zirgi vienam jātniekam",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Salīdzinājums balstīts uz publiski pieejamām funkcijām 2026. gada janvārī. EquiSight ir unikāls ar protokola analīzi un EPI, apvienojot to ar vispārēju zirgu pārvaldību.",
    },
    why: {
      title: "Kāpēc EquiSight piedāvā atšķirīgu treneris pieredzi.",
      lead: "Lielākā daļa treneris rīku beidzas tur, kur nodarbība beidzas. EquiSight turpina — zirga dossjē, sacensību analīzē, sadarbībā ar veterinārārstu un īpašnieku.",
      points: [
        {
          icon: "TrendingUp",
          title: "Protokola skenēšana → treniņa mērķis",
          body: "Skenē KNHS protokolu un uzreiz redzi, kuriem elementiem nepieciešama uzmanība. Mērķi parādās automātiski.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach pastiprina tavu skatu",
          body: "Dati no vairākām nodarbībām, sacensībām un protokoliem atklāj modeļus, ko nevar paturēt galvā.",
        },
        {
          icon: "Share2",
          title: "Integrēts ar zirgu",
          body: "Treneris redz zirga vakcinācijas, kalēja un traumu vēsturi — nav jāplāno treniņi atveseļošanās laikā.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Iejādei un pārlēkšanai",
      title: "Ko satur koučinga dossjē EquiSight sistēmā.",
      lead: "Katrai kombinācijai ir koučinga plūsma, kas tur visu kopā — nekas vairs nepazūd WhatsApp sarakstēs.",
      items: [
        "Nodarbību piezīmes ar fokusa punktiem katrā sesijā",
        "Ilgtermiņa mērķi un atskaites punkti",
        "Video augšupielāde ar laikakoda komentāriem",
        "KNHS/FEI protokola skenēšana ar rezultātiem",
        "Žūrijas komentāri saistīti ar treniņu",
        "Sacensību rezultāti un EPI tendence",
        "Klientu kontakts un nodarbību vēsture",
        "Nodarbību karte / abonaments / rēķini",
        "Progresa grafiks pa disciplīnām",
        "Koplietota piekļuve ar zirga īpašnieku",
      ],
      ctaLabel: "Apskatīt treneris moduli",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "No WhatsApp un YouTube uz EquiSight Trainer.",
      lead: "Konkrēti: tā mainās tavs koučinga darba process.",
      rows: [
        {
          before: "WhatsApp ar atsevišķām video saitēm",
          after: "Video ar laikakoda atsauksmēm dossjē",
        },
        {
          before: "Piezīmju blociņš katram jātniekam",
          after: "Koučinga žurnāls ar mērķiem un vēsturi",
        },
        {
          before: "Excel ar sacensību rezultātiem",
          after: "EPI grafiks un protokola analīze",
        },
        {
          before: "Mutiski mērķi",
          after: "Atskaites punkti ar progresa indikatoru",
        },
        {
          before: "Atsevišķs rēķinēšanas rīks",
          after: "Nodarbības, iDEAL un abonaments lietotnē",
        },
        {
          before: "E-pasts īpašniekam par progresu",
          after: "Īpašnieks seko līdzi savā skatā",
        },
      ],
    },
    helper: {
      title: "Kura treneris lietotne der tieši tev?",
      lead: "5 jautājumi, lai noskaidrotu, vai specializēts koučinga rīks sniedz pievienoto vērtību tavai praksei.",
      questions: [
        {
          id: "clients",
          q: "Cik aktīvas kombinācijas tu trenē?",
          options: [
            {
              label: "Mazāk par 5",
              score: 1,
            },
            {
              label: "5–15",
              score: 2,
            },
            {
              label: "Vairāk par 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Kāda ir tava galvenā disciplīna?",
          options: [
            {
              label: "Iejāde",
              score: 3,
            },
            {
              label: "Pārlēkšana",
              score: 2,
            },
            {
              label: "Rekreatīvi / dažādi",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Vai izmanto video koučingā?",
          options: [
            {
              label: "Reti",
              score: 0,
            },
            {
              label: "Dažreiz (manuāli)",
              score: 2,
            },
            {
              label: "Bieži — sistemātiski",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Vai trenē sacensību jātniekus?",
          options: [
            {
              label: "Nē, rekreatīvi",
              score: 0,
            },
            {
              label: "Dažreiz sacensības",
              score: 2,
            },
            {
              label: "Daudz — startkaršu pārvaldība centrālā",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Vai vēlies mērīt savu koučingu?",
          options: [
            {
              label: "Nē, pietiek ar intuīciju",
              score: 0,
            },
            {
              label: "Gribētu, bet nav laika",
              score: 2,
            },
            {
              label: "Jā — uz datiem balstīts koučings",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Vienkāršs rīks vai pat WhatsApp pagaidām pietiek.",
          body: "Mazāk par 5 jātniekiem bez daudz video vai sacensībām koučinga lietotne ir lieka greznība. EquiSight sāk bez maksas, tāpēc vari to izmēģināt, kad prakse aug.",
          cta: "Sāc bez maksas",
        },
        mid: {
          title: "EquiSight Trainer padara tevi sistemātiski efektīvāku.",
          body: "Ar 5–15 kombinācijām tu katru mēnesi tērē stundas WhatsApp un atsevišķiem video. EquiSight apvieno visu, automātiski skenē protokolus un nodrošina, ka jātnieki vienmēr var apskatīt savas atsauksmes.",
          cta: "Izmēģini treneris moduli",
        },
        high: {
          title: "EquiSight ir veidots tavai koučinga mērogam.",
          body: "Daudz jātnieku, video, sacensības un uz datiem balstīts koučings — tieši šeit EquiSight izceļas. EPI, protokola skenēšana un zirga dossjē dod tev priekšrocību, kādas konkurentiem nav.",
          cta: "Plāno demo savai koučinga praksei",
        },
      },
    },
    faqTitle: "Biežāk uzdotie jautājumi par treneris lietotnēm",
    faq: [
      {
        q: "Kura ir labākā treneris lietotne zirgiem un jātniekiem?",
        a: "Tīrai saziņai daudzi rīki pietiek (pat WhatsApp). Mērķiem, video analīzei, protokolu skenēšanai, sacensību izsekošanai un klientu pārvaldībai vienā rīkā EquiSight ir visaptverošākais risinājums — jo īpaši tāpēc, ka tas seko pašam zirgam, nevis tikai kombinācijai.",
      },
      {
        q: "Vai EquiSight var automātiski nolasīt sacensību protokolus?",
        a: "Jā. Augšupielādē KNHS vai FEI protokolu un EquiSight izvelk rezultātus pa elementiem, žūrijas komentārus un saista tos ar kombināciju. Tendences redzamas vairāku sacensību griezumā.",
      },
      {
        q: "Kas ir EPI (Equestrian Performance Index)?",
        a: "EPI ir EquiSight rādītājs, kas vairākus sacensību rezultātus pārvērš salīdzināmā snieguma indeksā. Tādējādi var redzēt patiesu progresu dažādās klasēs un pie dažādiem tiesnešiem.",
      },
      {
        q: "Vai jātnieki var paši pierakstīties nodarbībām un maksāt?",
        a: "Jā. Jātnieki piesakās, redz pieejamos nodarbību laikus, pērk nodarbību kartes un maksā ar iDEAL. Tu pats lemj, ko vēlies piedāvāt.",
      },
      {
        q: "Vai tas darbojas arī instruktoram, kas strādā manēžas apkārtnē?",
        a: "Jā. Kā brīvmākslinieks treneris vari strādāt ar saviem klientiem, nepievienojot manēžas kontu. Klienti maksā tev tieši.",
      },
      {
        q: "Vai varu migrēt esošos video un piezīmes?",
        a: "Video vari augšupielādēt pa kombinācijām vai izmantot grupveida augšupielādes rīku. Piezīmes importē ar CSV. Aktīviem treneriem palīdzam ar vienreizēju migrāciju.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Ceļveži un izvēles palīgi zirgu pārvaldības programmatūrai | EquiSight",
      description: "Visi EquiSight ceļveži vienā vietā: zirgu pārvaldība, audzēšana, manēžas un treneŗa programmatūras salīdzinājumi, kā arī izvēles palīgi 2026. gadam.",
      keywords: [
        "zirgu programmatūras ceļveži",
        "zirgu pārvaldības izvēles palīgs",
        "audzēšanas programmatūras salīdzinājums",
        "manēžas programmatūras ceļvedis",
        "treneŗa lietotnes salīdzinājums",
      ],
    },
    hub: {
      eyebrow: "Centrmezgls · ceļveži",
      breadcrumbLabel: "Ceļveži",
      title: "Četri pilnīgi ceļveži, lai izvēlētos piemērotāko zirgu programmatūru.",
      intro: "Katrai mērķauditorijai padziļināts izvēles palīgs: salīdzināšanas tabulas, kritēriji, piemēri un interaktīva viktorīna. Noklikšķiniet uz ceļveža, kas atbilst jūsu situācijai, vai vispirms izpētiet padziļinātos rakstus zem katras kopas.",
      stats: {
        guides: "4 izvēles palīgi",
        articles: "15 padziļināti raksti",
        fair: "Godīgs salīdzinājums",
      },
      readMoreCta: "Lasiet pilno ceļvedi",
      relatedHeading: "Padziļināti raksti",
      articlesCountSingular: "{{count}} padziļināts raksts",
      articlesCountPlural: "{{count}} padziļināti raksti",
      articlesCountAria: "Kopas rakstu skaits",
      lastUpdatedPrefix: "Atjaunināts",
      lastUpdatedAria: "Šīs kopas pēdējā atjauninājuma datums",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Zirgu pārvaldības lietotnes izvēles palīgs",
        blurb: "Salīdziniet populārākās zirgu pārvaldības lietotnes un atklājiet, kura der īpašniekam, stallim vai audzētavai. Iekļauta godīga salīdzināšanas tabula un 5 jautājumu izvēles palīgs.",
        audience: "Zirgu īpašniekiem, stalļu turētājiem un visiem zirgu cilvēkiem, kas meklē pārskatu.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Audzēšanas programmatūras salīdzinājums",
        blurb: "No ķēves cikla līdz kumeļa attīstībai: skatiet, kura audzēšanas programmatūra patiešām darbojas atbilstoši jūsu ķēvju skaitam, audzēšanas metodei un ciltsgrāmatas prasībām.",
        audience: "Hobija un profesionāliem audzētājiem, audzētavām un ērzeļu turētājiem.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Manēžas programmatūras izvēles palīgs",
        blurb: "Nodarbību plānošana, jātnieku administrācija, īpašnieku portāls un rēķinu izrakstīšana — vienā rīkā. Salīdziniet manēžu un pensionātu staļļu iespējas 2026. gadā.",
        audience: "Manēžām, pensionātu staļļiem un jāšanas uzņēmumiem.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Treneŗa lietotnes izvēles palīgs",
        blurb: "Trenēšanas CRM, video atsauksmes, KNHS protokola skenēšana un mērķi katram pārim. Kura treneŗa lietotne atbilst jūsu trenēšanas praksei?",
        audience: "Instruktoriem, treneriem un koučiem.",
      },
    ],
    closing: {
      eyebrow: "Kāpēc šie ceļveži",
      title: "Godīgs salīdzinājums, ne tikai cenas.",
      body1: "Daudzas \"salīdzināšanas lapas\" patiesībā ir slēptas reklāmas. Mūsu ceļveži salīdzina funkcijas, mērķauditoriju un konkurentus tā, kā to darītu neatkarīgs zināšanu avots. EquiSight dabīgi izceļas kā pilnīgs risinājums, taču jūs arī godīgi uzzināsiet, kur citas lietotnes ir spēcīgākas.",
      body2: "Padziļinātie raksti zem katra ceļveža atbild uz konkrētiem jautājumiem, kas rodas izvēles procesā: \"Kad pirmais ultraskaņas izmeklējums pēc apsēklošanas\", \"Kā automatizēt manēžas rēķinu izrakstīšanu\", \"Kā analizēt sacensību protokolu\". Bez mārketinga tukšvārdiem — tikai prakse.",
    },
    hubName: "EquiSight Ceļveži",
  },
  ui: {
    sectionEyebrows: {
      pains: "Kāpēc tas sagādā sāpes",
      basics: "Pamati",
      criteria: "Kas padara to labu?",
      comparison: "Godīgs salīdzinājums",
      why: "Atšķirība",
      beforeAfter: "No sadrumstalotības uz pārskatu",
      helper: "5 jautājumi",
    },
    table: {
      feature: "Funkcija",
      today: "Šodien",
      withEquisight: "Ar EquiSight",
    },
    helper: {
      questionLabel: "Jautājums {{current}} no {{total}}",
      answerPrompt: "Atbildiet uz {{count}} atlikušo jautājumu, lai redzētu ieteikumu.",
      answerPromptPlural: "Atbildiet uz {{count}} atlikušajiem jautājumiem, lai redzētu ieteikumu.",
      resultEyebrow: "Jūsu rezultāts",
    },
    targetGroupsFallback: "Kam tas paredzēts?",
    faqTitleFallback: "Bieži uzdotie jautājumi",
  },
};

export default CORNERSTONES;
